/* eslint-disable */
import React from 'react';
import 'contents/assets/scss/page/training.scss';

const TrainerManage = () => {
  return (
    <main className="com_container com_training p_trainer_manage">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu6_5">교관 관리</h2>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_board_list__top">
              <section className="com_board_search end">
                <select className="select">
                  <option value="선택">선택</option>
                </select>
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
                <div className="com_input_wrap">
                  <select className="select">
                    <option value="기수선택">기수선택</option>
                  </select>
                  <button className="com_btn gray s">등록</button>
                </div>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="60" />
                <col width="290" />
                <col width="290" />
                <col width="290" />
                <col width="290" />
                <col width="290" />
              </colgroup>
              <thead>
                <tr>
                  <th>
                    <input type="checkbox" name="chk" id="chkAll" className="com_chk" />
                    <label htmlFor="chkAll"></label>
                  </th>
                  <th>등록일</th>
                  <th>비고</th>
                  <th>기수</th>
                  <th>교관명</th>
                  <th>전화번호</th>
                </tr>
              </thead>
              <tbody>
                {[...Array(8)].map((i, idx) => (
                  <tr key={idx}>
                    <td>
                      <input type="checkbox" name="chk" id={`chk${idx}`} className="com_chk" />
                      <label htmlFor={`chk${idx}`}></label>
                    </td>
                    <td className="td_date">2022,08,25</td>
                    <td>관리자</td>
                    <td>1기수</td>
                    <td>
                      <span className="btn_link">홍길동123</span>
                    </td>
                    <td>010-1234-1324</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="com_btn_wrap">
              <button className="com_btn s gray">선택한 교관 삭제</button>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
};

export default TrainerManage;
